import React, { useState, useEffect } from 'react'
import { useAuth } from '../../contexts/AuthContext'

export default function LoginPage() {
  const { signIn } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [rememberMe, setRememberMe] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const saved = localStorage.getItem('pietila_remember')
    if (saved) {
      const { email: savedEmail } = JSON.parse(saved)
      setEmail(savedEmail)
      setRememberMe(true)
    }
  }, [])

  const handleLogin = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    if (rememberMe) {
      localStorage.setItem('pietila_remember', JSON.stringify({ email }))
    } else {
      localStorage.removeItem('pietila_remember')
    }
    const { error } = await signIn(email, password)
    if (error) setError(error.message)
    setLoading(false)
  }

  return (
    <div style={styles.container}>
      <div style={styles.bg} />
      <div style={styles.grid} />
      <div style={styles.card}>
        <div style={styles.logoBlock}>
          <img src="/cp-quality-logo.png" alt="CP Quality Pools" style={styles.logoMark} />
          <div>
            <div style={styles.logoName}>PIETILA GROUP</div>
            <div style={styles.logoSub}>OPERATIONS PLATFORM</div>
          </div>
        </div>
        <div style={styles.divider} />
        <div style={styles.businesses}>
          <div style={styles.bizTag}>CP QUALITY POOLS</div>
          <div style={styles.dot} />
          <div style={styles.bizTag}>RIVERBEND CLEARING</div>
        </div>
        <form onSubmit={handleLogin} style={styles.form}>
          <div style={styles.fieldGroup}>
            <label style={styles.label}>EMAIL</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} style={styles.input} placeholder="your@email.com" required />
          </div>
          <div style={styles.fieldGroup}>
            <label style={styles.label}>PASSWORD</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} style={styles.input} placeholder="********" required />
          </div>
          <label style={styles.rememberRow}>
            <input type="checkbox" checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} style={styles.checkbox} />
            <span style={styles.rememberText}>REMEMBER ME</span>
          </label>
          {error && <div style={styles.error}>{error}</div>}
          <button type="submit" disabled={loading} style={styles.btn}>{loading ? 'SIGNING IN...' : 'SIGN IN'}</button>
        </form>
        <div style={styles.footer}>(810) 923-6229 &nbsp;&middot;&nbsp; pietilagroup.com</div>
      </div>
    </div>
  )
}

const styles = {
  container: { minHeight: '100vh', backgroundColor: '#0a0f1a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', position: 'relative', overflow: 'hidden', fontFamily: "'Barlow', sans-serif" },
  bg: { position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at 20% 50%, rgba(180,140,60,0.08) 0%, transparent 60%), radial-gradient(ellipse at 80% 20%, rgba(30,80,50,0.1) 0%, transparent 50%)' },
  grid: { position: 'absolute', inset: 0, backgroundImage: 'linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)', backgroundSize: '40px 40px' },
  card: { position: 'relative', width: '100%', maxWidth: '420px', backgroundColor: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '4px', padding: '48px 40px', backdropFilter: 'blur(20px)' },
  logoBlock: { display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '32px' },
  logoMark: { width: '52px', height: '52px', objectFit: 'contain', flexShrink: 0 },
  logoName: { fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: '22px', color: '#ffffff', letterSpacing: '3px', lineHeight: 1.1 },
  logoSub: { fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 400, fontSize: '11px', color: '#b48c3c', letterSpacing: '3px', marginTop: '2px' },
  divider: { height: '1px', backgroundColor: 'rgba(255,255,255,0.06)', marginBottom: '20px' },
  businesses: { display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '36px' },
  bizTag: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: '10px', fontWeight: 600, letterSpacing: '2px', color: 'rgba(255,255,255,0.35)' },
  dot: { width: '3px', height: '3px', borderRadius: '50%', backgroundColor: '#b48c3c' },
  form: { display: 'flex', flexDirection: 'column', gap: '20px' },
  fieldGroup: { display: 'flex', flexDirection: 'column', gap: '8px' },
  label: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: '11px', fontWeight: 600, letterSpacing: '2px', color: 'rgba(255,255,255,0.4)' },
  input: { backgroundColor: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '3px', padding: '14px 16px', color: '#ffffff', fontSize: '16px', fontFamily: "'Barlow', sans-serif", outline: 'none', transition: 'border-color 0.2s' },
  rememberRow: { display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', marginTop: '-8px' },
  checkbox: { accentColor: '#b48c3c', width: '16px', height: '16px', cursor: 'pointer' },
  rememberText: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: '11px', fontWeight: 600, letterSpacing: '2px', color: 'rgba(255,255,255,0.4)' },
  error: { backgroundColor: 'rgba(220,60,60,0.1)', border: '1px solid rgba(220,60,60,0.3)', borderRadius: '3px', padding: '12px 16px', color: '#ff6b6b', fontSize: '14px' },
  btn: { backgroundColor: '#b48c3c', border: 'none', borderRadius: '3px', padding: '16px', color: '#0a0f1a', fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: '16px', letterSpacing: '3px', cursor: 'pointer', marginTop: '8px', transition: 'background-color 0.2s' },
  footer: { marginTop: '32px', textAlign: 'center', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '11px', letterSpacing: '1px', color: 'rgba(255,255,255,0.2)' },
}